const requiredEnvVars = [
  "REACT_APP_AZURE_CLIENT_ID",
  "REACT_APP_AZURE_AUTHORITY",
  "REACT_APP_AZURE_KNOWN_AUTHORITIES",
  "REACT_APP_AZURE_SCOPE",
  "REACT_APP_BASE_URL",
  "REACT_APP_B2C_SCOPE",
  "REACT_APP_IDM_BUS_ACCOUNT_MANAGE",
  "REACT_APP_IDM",
  "REACT_APP_MONERIS_ENV",
  "REACT_APP_APPINSIGHTS_CONNECTION_STRING",
  "REACT_APP_MONERIS_SCRIPT_URL",
] as const;

export function validateEnv() {
  const missingVars = requiredEnvVars.filter((envVar) => !process.env[envVar]);

  if (missingVars.length > 0) {
    throw new Error(
      `Missing required environment variables:\n${missingVars.join(
        "\n",
      )}\n\nPlease check your .env file and ensure all required variables are set.`,
    );
  }
}
